import {createAction} from 'util/redux'
import {ClipboardValue} from 'module/Clipboard/type/ClipboardTypes'

const NAMESPACE = "CLIPBOARD/";
export const clipboardCopyAction = createAction<{ clipboardName: string, value: ClipboardValue }>(NAMESPACE + 'copy')